import React from 'react';

const Sort = ({ width, height, theme }) => (
  <svg width={width || '18'} height={height || '18'} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill={theme === 'desc' ? '#4295DB' : '#979797'} d="M9 4.3725L11.3775 6.75L12.435 5.6925L9 2.25L5.5575 5.6925L6.6225 6.75L9 4.3725Z" />
    <path fill={theme === 'asc' ? '#4295DB' : '#979797'} d="M6.6225 11.25L9 13.6275L11.3775 11.25L12.4425 12.3075L9 15.75L5.565 12.3075L6.6225 11.25Z" />
  </svg>
);

export default Sort;